<template>
  <div class="activity" @click="$parent.onCourseClick(activity, activity.fileType)">
    <div class="d-flex align-items-center no-gutters">
      <div class="xp-borders d-flex flex-column">
        <div class="xp-border" style="max-height: 38px !important;"></div>
        <div class="card-number display-h4
                          font-weight-bold text-primary mr-2">
          {{ order }}
        </div>
        <div class="xp-border"></div>
      </div>
      <ProgressDonut class="pl-4 pr-3 align-self-start"
                     :object="activity"
                     :small="false"
                     :overlay="true"
                     :locked="!activity.available"
                     :orgId="activity.organization_id"
                     :check-dates="false"/>
      <div class="texts">
        <div class="display-h7">
          <div v-if="activity.duration > 0" class="pr-2">
            {{ $t('session.card.duration') }}
            <span class="font-weight-bold">{{ activity.duration }}</span>
            {{ $t('session.card.duration.min') }}
          </div>
        </div>
        <h5 class="mb-1"
            :style="[!activity.available ? {'color': 'var(--secondary-lighter)'}:{}]">
          {{ activity.name | str_limit(50)}}
        </h5>
        <p class="display-h7"
           :style="[!activity.available ? {'color': 'rgb(97, 97, 97)'}:{}]">
          {{ activity.description | str_limit(showDescription?10000:100)}}
          <button
                  v-if="longDescription"
                  class="font-weight-light btn btn-outline-primary btn-xsm position-relative"
                  @click.stop="showDescription = !showDescription">
            {{ !showDescription ? $t('show.more'):$t('show.less') }}</button>
        </p>
        <inline-svg
          v-if="statsAvailable"
          class="position-relative cursor-hand"
          @click="$parent.loadStats($event,activity.glue)"
          width="18" height="18"
          :src="require('@/assets/images/icons/Icon_Score.svg')"/>
      </div>
      <div class="card-status" v-if="activity.completed === '1'" >
        <img v-if="activity.success === '1'"
             src="@/assets/images/icons/Icon_InGameValidate-svg-green.svg"
             alt="success image">
        <img v-else
             src="@/assets/images/icons/Icon_InGameNoValidate-red.svg"
             alt="fail image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Activity',
  props: {
    activity: {
      type: Object,
      default: null,
    },
    order: {
      type: Number,
      default: 0,
    },
    statsAvailable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showDescription: false,
      longDescription: this.activity.description && this.activity.description.length > 100,
    };
  },
};
</script>

<style scoped>

</style>
